import { AxiosPromise } from "axios";
import configs from "../configs";
import { AssetModel, ReportBreakdown } from '../interfaces/models';
import { BreakdownLiveApis } from "./live/breakdownLiveApis";


export class BreakdownApis {
    private static breakdownApi: BreakdownLiveApis = new BreakdownLiveApis();



    static deleteBreakdownByAccountIdAndBreakdownId(breakdownId: string, accountId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.deleteBreakdownByAccountIdAndBreakdownId(breakdownId, accountId);
        }
    }




    static updateBreakdownTools(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateBreakdownTools(data);
        }
    }


    static getInventoryItems(accountId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getInventoryItems(accountId);
        }
    }




    static getBreakdownByAccountId(account: string, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getBreakdownByAccountId(account, pageSize, pageNumber, sort);
        }
    }


    static getSingleBreakdownByAccountId(account: string, breakdownId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getSingleBreakdownByAccountId(account, breakdownId);
        }
    }



    static filterBreakdownByAccountId(breakdownData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.filterBreakdownByAccountId(breakdownData, pageSize, pageNumber, sort);
        }
    }



    static filterBreakdownByAssetId(breakdownData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.filterBreakdownByAssetId(breakdownData, pageSize, pageNumber, sort);
        }
    }


    static getAssetToServiceByAssetId(assetId: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getAssetToServiceByAssetId(assetId, pageSize, pageNumber, sort);
        }
    }



    static filterServiceByAccountId(serviceData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.filterServiceByAccountId(serviceData, pageSize, pageNumber, sort);
        }
    }



    static createBreakdownActivity(data: any, accountId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.createBreakdownActivity(data, accountId);
        }
    }


    // ==================== TOOLS APIs ====================

    static getBreakdownTools(accountId: string, breakdownId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getBreakdownTools(accountId, breakdownId);
        }
    }

    static addBreakdownTools(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.addBreakdownTools(data);
        }
    }

    static removeBreakdownTool(accountId: string, breakdownId: string, toolId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.removeBreakdownTool(accountId, breakdownId, toolId);
        }
    }

    static addChecklist(data: any, id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.addChecklist(data, id);
        }
    }



    static createCategory(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.createCategory(data);
        }
    }

    static getCategory(accountId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getCategory(accountId);
        }
    }

    static getServiceSchedules(accountId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getServiceSchedules(accountId);
        }
    }

    static getSingleServiceContract(id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getSingleServiceContract(id);
        }
    }

    static getServiceContractById(id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getServiceContractById(id);
        }
    }

    static updateCategory(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateCategory(data);
        }
    }

    static updateServiceContractStatus(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateServiceContractStatus(data);
        }
    }


    static startService(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.startService(data);
        }
    }


    static getApproval(data: any, id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getApproval(data, id);
        }
    }

    static getApprovalForScheduleAsset(data: any, id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getApprovalForScheduleAsset(data, id);
        }
    }

    static getExternalApprovalUrl(scheduleId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getExternalApprovalUrl(scheduleId);
        }
    }

    static getPublicSchedule(scheduleId: string, expiry: string, token: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.breakdownApi.getPublicSchedule(scheduleId, expiry, token);
    }

    static approvePublicSchedule(scheduleId: string, expiry: string, token: string, data: FormData): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.breakdownApi.approvePublicSchedule(scheduleId, expiry, token, data);
    }

    static getExternalApprovalUrlForAsset(assetId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.breakdownApi.getExternalApprovalUrlForAsset(assetId);
    }

    static getPublicScheduleAsset(scheduleAssetId: string, expiry: string, token: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.breakdownApi.getPublicScheduleAsset(scheduleAssetId, expiry, token);
    }

    static approvePublicScheduleAsset(id: string, expiry: string, token: string, data: FormData): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.breakdownApi.approvePublicScheduleAsset(id, expiry, token, data);
    }

    // To Change the status of the Asset Schedule
    static updateScheduleAssetStatus(scheduleId: string, assetData: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.breakdownApi.updateScheduleAssetStatus(scheduleId, assetData);
    }



    static getApprovalRemark(data: any, id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getApprovalRemark(data, id);
        }
    }

    static completeService(accountId: any, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.completeService(accountId, data);
        }
    }

    static completeAssetService(serviceId: any, assetId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.completeAssetService(serviceId, assetId);
        }
    }


    static completeScheduleAssetService(serviceId: any, assetId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.completeScheduleAssetService(serviceId, assetId);
        }
    }





    static addScheduleChecklist(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.addScheduleChecklist(data);
        }
    }




    static missedReason(id: any, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.missedReason(id, data);
        }
    }

    static deleteSchedule(id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.deleteSchedule(id);
        }
    }



    static deleteContract(id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.deleteContract(id);
        }
    }




    static getServiceDetails(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getServiceDetails(data);
        }
    }



    static getScheduleChecklist(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getScheduleChecklist(data);
        }
    }

    static updateChecklistData(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateChecklistData(data);
        }
    }

    static deleteChecklist(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.deleteChecklist(data);
        }
    }



    static getBreakdownActivities(breakdownData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getBreakdownActivities(breakdownData, pageSize, pageNumber, sort);
        }
    }

    static deleteBreakdownActivity(activityId: any, accountId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.deleteBreakdownActivity(activityId, accountId);
        }
    }


    static assignBreakdownToUser(breakdown: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.assignBreakdownToUser(breakdown);
        }
    }


    static getServiceAggregate(accountId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getServiceAggregate(accountId);
        }
    }


    static assignUserToSchedule(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.assignUserToSchedule(data);
        }
    }


    static viewedBreakdownActivities(accountId: any, breakdownId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.viewedBreakdownActivities(accountId, breakdownId);
        }
    }



    static searchServiceData(serviceData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.searchServiceData(serviceData, pageSize, pageNumber, sort);
        }
    }





    static addResolution(resolution: any, accountId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.addResolution(resolution, accountId);
        }
    }

    static updateResolveTime(resolution: any, accountId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateResolveTime(resolution, accountId);
        }
    }


    static updateResponseTime(resolution: any, accountId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateResponseTime(resolution, accountId);
        }
    }


    static updateCost(resolution: any, accountId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateCost(resolution, accountId);
        }
    }

    static scheduleService(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.scheduleService(data);
        }
    }

    static updateScheduleService(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateScheduleService(data);
        }
    }




    static reportBreakdown(breakdown: any, accountId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.reportBreakdown(breakdown, accountId);
        }
    }

    static reportPublicBreakdown(breakdown: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.reportPublicBreakdown(breakdown);
        }
    }


    static createWorkOrder(orderData: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.createWorkOrder(orderData);
        }
    }

    static updateWorkOrder(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateWorkOrder(data);
        }
    }


    static updateProgressPercentage(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateProgressPercentage(data);
        }
    }

    static requestReview(workId: string, reviewerId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.requestReview(workId, reviewerId);
        }
    }

    static respondToReview(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.respondToReview(data);
        }
    }

    static updateBreakdownStatus(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateBreakdownStatus(data);
        }
    }






    static getBreakdownAggregateByAccountId(accountId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getBreakdownAggregateByAccountId(accountId);
        }
    }
    static getBreakdownAnalyticsByAccountIdAndBreakdownType(accountId: any, breakdownType: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getBreakdownAnalyticsByAccountIdAndBreakdownType(accountId, breakdownType);
        }
    }

    static getBreakdownStatByAccountId(account: string, year: string, month: string, catId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getBreakdownStatByAccountId(account, year, month, catId);
        }
    }


    static getCategoryHistoryByAccountId(account: string, year: string, month: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getCategoryHistoryByAccountId(account, year, month);
        }
    }

    // Report Schedule
    static createReportSchedule(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.createReportSchedule(data);
        }
    }

    static searchReportSchedule(searchData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.searchReportSchedule(searchData, pageSize, pageNumber, sort);
        }
    }

    static getReportScheduleByReportId(reportId: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getReportScheduleByReportId(reportId);
        }
    }

    static deleteReportSchedule(reportId: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.deleteReportSchedule(reportId);
        }
    }
    // ==================== CHECKLIST APIs ====================

    static getWorkOrderChecklists(accountId: string, workOrderId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getWorkOrderChecklists(accountId, workOrderId);
        }
    }

    static createWorkOrderChecklist(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.createWorkOrderChecklist(data);
        }
    }

    static updateWorkOrderChecklist(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateWorkOrderChecklist(data);
        }
    }

    static toggleWorkOrderChecklist(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.toggleWorkOrderChecklist(data);
        }
    }

    static deleteWorkOrderChecklist(accountId: string, workOrderId: string, checklistId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.deleteWorkOrderChecklist(accountId, workOrderId, checklistId);
        }
    }

    // ==================== PURCHASED ITEMS APIs ====================

    static searchBreakdownParts(
        pageSize: number,
        pageNumber: number,
        sort: string = 'Descending',
        queryString: string,
        status: string,
        actionType: string,
        all: boolean = false
    ): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.searchBreakdownParts(pageSize, pageNumber, sort, queryString, status, actionType, all);
        }
    }

    static getWorkOrderPurchasedItems(accountId: string, workOrderId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.getWorkOrderPurchasedItems(accountId, workOrderId);
        }
    }

    static createWorkOrderPurchasedItem(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.createWorkOrderPurchasedItem(data);
        }
    }

    static updateWorkOrderPurchasedItem(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateWorkOrderPurchasedItem(data);
        }
    }

    static deleteWorkOrderPurchasedItem(accountId: string, workOrderId: string, itemId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.deleteWorkOrderPurchasedItem(accountId, workOrderId, itemId);
        }
    }


    static deleteBreakdownPart(itemId: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.deleteBreakdownPart(itemId);
        }
    }


    static completePartReturn(formData: FormData): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.completePartReturn(formData);
        }
    }



    static updateReportSchedule(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateReportSchedule(data);
        }
    }


    static updateReportScheduleStatus(scheduleId: string, status: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.updateReportScheduleStatus(scheduleId, status);
        }
    }


    static searchReportFiles(searchData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.searchReportFiles(searchData, pageSize, pageNumber, sort);
        }
    }

    static deleteReportFile(id: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.deleteReportFile(id);
        }
    }


    static downloadReportFile(filePath: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.breakdownApi.downloadReportFile(filePath);
        }
    }


}